import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

const slides = [
  { src: img("balivwtour/home/header-home-01.jpg"), altKey: "hero_img_alt_1" },
  { src: img("balivwtour/home/hero-slider-01.jpg"), altKey: "hero_img_alt_2" },
  { src: img("balivwtour/home/hero-slider-02.jpg"), altKey: "hero_img_alt_3" },
  { src: img("balivwtour/home/hero-slider-03.jpg"), altKey: "hero_img_alt_4" },
  { src: img("balivwtour/home/hero-slider-04.jpg"), altKey: "hero_img_alt_5" },
  { src: img("balivwtour/home/hero-slider-05.jpg"), altKey: "hero_img_alt_6" },
  { src: img("balivwtour/home/hero-slider-06.jpg"), altKey: "hero_img_alt_7" },
  { src: img("balivwtour/home/hero-slider-07.jpg"), altKey: "hero_img_alt_8" },
  { src: img("balivwtour/home/hero-slider-08.jpg"), altKey: "hero_img_alt_9" },
  { src: img("balivwtour/home/hero-slider-09.jpg"), altKey: "hero_img_alt_10" },
  { src: img("balivwtour/home/hero-slider-010.jpg"), altKey: "hero_img_alt_11" },
  { src: img("balivwtour/home/hero-slider-011.jpg"), altKey: "hero_img_alt_12" },
];

export default function Hero() {
  const { t } = useTranslation();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setIdx((p) => (p + 1) % slides.length), 5500);
    return () => clearInterval(timer);
  }, []);

  // Nächstes Bild im Hintergrund vorladen, damit die Überblendung nicht hakt.
  useEffect(() => {
    const next = new Image();
    next.src = slides[(idx + 1) % slides.length].src;
  }, [idx]);

  return (
    <section id="top" className="relative h-[640px] md:h-[760px] w-full overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={slide.src}
          className={`absolute inset-0 transition-opacity duration-[1500ms] ${i === idx ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.src}
            alt={t(slide.altKey)}
            title={t("hero_slider_title")}
            loading={i === 0 ? "eager" : "lazy"}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-4">
        <div className="mb-6 md:mb-7 text-accent-300 text-[11px] md:text-sm font-medium tracking-[0.18em] md:tracking-[0.32em] uppercase max-w-3xl leading-relaxed">
          {t("hero_eyebrow")}
        </div>
        <h1 className="font-heading text-background-50 text-[1.4rem] md:text-[2.25rem] lg:text-[2.9rem] font-semibold max-w-5xl leading-[1.08] tracking-tight text-balance">
          {t("hero_welcome")}
        </h1>
        <p className="mt-6 text-background-100 text-base md:text-xl font-light max-w-2xl leading-relaxed text-balance hyphens-none">
          {t("hero_sub")}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <LocalizedLink
            to="/your-stay"
            className="inline-flex items-center justify-center gap-2 bg-transparent border border-background-50/70 text-background-50 hover:border-primary-500 hover:bg-primary-600/20 text-background-50 px-9 py-3.5 rounded-md font-semibold uppercase tracking-wider whitespace-nowrap cursor-pointer transition-colors text-sm"
          >
            {t("hero_cta")}
          </LocalizedLink>
          <LocalizedLink
            to="/activities"
            className="inline-flex items-center justify-center gap-2 bg-transparent border border-background-50/70 text-background-50 hover:border-primary-500 hover:bg-primary-600/20 text-background-50 px-9 py-3.5 rounded-md font-semibold uppercase tracking-wider whitespace-nowrap cursor-pointer transition-colors text-sm"
          >
            {t("hero_trip_cta")}
          </LocalizedLink>
        </div>

        <div className="absolute bottom-8 flex gap-2">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                i === idx ? "bg-accent-400 w-10" : "bg-background-50/50 w-4 hover:bg-background-50/80"
              }`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}